import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { User, UserService } from '../shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../shared/config/app-config';
import { SucesstempComponent } from '../sucesstemp/sucesstemp.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
declare var bootstrap: any;

@Component({
  selector: 'app-need-help',
  templateUrl: './need-help.component.html',
  styleUrls: ['./need-help.component.css', '../hospital/dash/style.component.css']
})

export class NeedHelpComponent implements OnInit {
  selectedMaterial: any = null;
  modalRef?: BsModalRef;
  materialsList = [];
  overallMaterialsList = [];
  imageURL = environment.cloudeImageURL;
  @ViewChild('videoModal') videoModal!: ElementRef;
  documenturl: string = environment.documenturl;
  searchText = "";
  language = "en";
  materialSubscription: Subscription;
  languageSubscription: Subscription;
  languageConfig = {
    "multiLanguageRequired" : false,
    "languages": [],
    "userName": ''
  };
  selectedTag = "Web";
  showloader = false;
  userEmail = '';
  isLoggedIn = false;
  CurrentUser: User;
  userSubscription : Subscription;
  constructor(private userService: UserService,
        private modalService: BsModalService,
        private router: Router,
        private translate: TranslateService
  ) { 
    
    if(this.router.url.includes("/patient/")) {
      this.isLoggedIn = true;
      this.language = this.userService.selectedLang();
    } else {
      this.userEmail = localStorage.getItem("UserEmail");
      let language = JSON.parse(localStorage.getItem("LanguageConfig"));
      if(!language || language == null) {
        this.backTOLogin();
      }
      this.languageConfig = language;
      this.language = this.userService.selectedLang();
      this.loadMaterials(1);
    }
  }

  ngOnInit(): void {
    this.userSubscription = this.userService.currentUser.subscribe(
			(userData) => {
				this.CurrentUser = userData;
				if (this.CurrentUser.item) {
          this.userEmail = this.CurrentUser.item.email;
          if(!this.userEmail) 
            this.userEmail = this.CurrentUser.item.phone;
          this.loadMaterials(1);
				}
			}
		)
  }

  getPreferredLanguage(emailTargetValue) {
    const credential = {
    'userName': emailTargetValue
  }
  this.showloader = true;
  this.languageSubscription =  this.userService.getLanguageConfig(credential).subscribe(
    langConfigRes => {
      if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
        if(langConfigRes?.multiLanguageRequired) {
          setTimeout(() => {
            const cnDropElement = document.getElementById("multilang") as HTMLSelectElement;
            if (cnDropElement) {
              cnDropElement.value = langConfigRes?.preferredlanguage;
            }
          }, 500);
        }
      } else this.showloader = false;
    });
  }

  backTOLogin() {
    let urlDetails = sessionStorage.getItem("backToPage");
    if (urlDetails && urlDetails != null) {
      let url = JSON.parse(urlDetails);
      this.userService.setCurrentLanguage(url?.currentLang);
      this.router.navigateByUrl(url?.currentURL || `/login`);
    } else {
      this.router.navigateByUrl(`/login`)
    }
  }

  languageChange() {
    this.userService.setCurrentLanguage(this.language, false)
    this.loadMaterials(this.selectedTag == "Web" ? 1 : 2);
  }

  loadMaterials(platform: number) {
    const credential = {
      "userName": this.userEmail,
      "materialTypeId": 2,
      "locale": this.language,
      "platformMode":platform
    }
    this.showloader = true;
    this.materialSubscription = this.userService.getMaterials(credential).subscribe(
      response => {
        this.showloader = false;
        this.materialsList = response['localeFAQ'] || [];
        this.overallMaterialsList = response['localeFAQ'] || [];
      }, (error:any) => {this.showloader = false;});
  }

  onSearchChange() {
    const search = this.searchText.toLowerCase();
    this.materialsList = this.overallMaterialsList.filter(m =>
      m.materialName.toLowerCase().includes(search)
    );
  }

  closeVideo() {
    this.modalRef.hide()
  }
  
  ngOnDestroy() {
    if (this.materialSubscription) {
      this.materialSubscription.unsubscribe();
    }
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    localStorage.removeItem("LanguageConfig");
    localStorage.removeItem("UserEmail")
  }

  openVideo(material: any, videoPlay: TemplateRef<any>) {
    this.selectedMaterial = material;
    this.iWatchedIt(this.selectedMaterial);
    this.modalRef = this.modalService.show(videoPlay, {
      class: 'modal-lg',
      backdrop: true,             // show backdrop (default)
      ignoreBackdropClick: true   // prevents closing when clicking outside
    });    
  }

  enablevideo: any = true
  iWatched(video) {
    if ((video.duration - video.currentTime) <= 4) {
      this.enablevideo = false
    } else {
      this.enablevideo = true
    }
  }

  iWatchedIt(video) {
    let payload = {
      "userName": this.userEmail,
      "localeFAQMasterId": this.selectedMaterial?.localeFAQMasterId,
      "viewSeconds": 0
    }
      this.userService.saveMaterialsAudit(payload)
        .subscribe(
          data => {

          });
    }
    
    getFullYear(){
      return new Date().getFullYear();
    }
}